module.exports = __webpack_public_path__ + "static/media/vibrant.2e35338e.png";